import { OnInit, OnDestroy } from '@angular/core';
import { EditPageComponent } from '../edit-page/edit-page.component';
import { PermissionService } from '../../../permission';
import { ActivatedRoute } from '@angular/router';
import { ServiceBase } from '../../../interfaces';
import { Observable } from 'rxjs';

export abstract class ImplementedEditPageComponent<T> extends EditPageComponent<T>
  implements OnInit, OnDestroy {
  constructor(
    protected readonly route: ActivatedRoute,
    protected readonly service: ServiceBase<T>,
    protected permissionService?: PermissionService,
    protected editPermission?: string,
  ) {
    super(permissionService, editPermission);
    this.route.params.subscribe(param => (this.id = +param.id));
  }

  public updateModel(): Observable<T> {
    return this.service.updateById(this.model, +this.id);
  }

  public getModel(): Observable<T> {
    return this.service.getById(+this.id);
  }

  public ngOnInit() {
    super.ngOnInit();
  }

  public ngOnDestroy() {
    super.ngOnDestroy();
  }
}
